import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { CheckCircle, WarningRounded } from '@material-ui/icons';
import { GREEN_MOBILE, YELLOW_MOBILE } from 'constants/colors';
import useRouter from 'hooks/useRouter';
import React, { FC } from 'react';

interface Props {
  open: boolean;
}
const useStyles = makeStyles((theme: Theme) => ({
  titleContainer: {
    fontWeight: 500,
    fontSize: '1.2rem'
  },
  button: {
    borderRadius: '15px',
    padding: '7px 0'
  }
}));
const ModalSuccess: FC<Props> = ({ open }) => {
  const classes = useStyles();
  const { history } = useRouter();
  const handleClick = () => {
    history.push('/penjualan');
  };
  return (
    <Dialog open={open} style={{ maxHeight: 80 + 'vh', marginTop: '60px' }} scroll='paper' fullWidth>
      <DialogTitle>
        <Grid item container direction='column' alignItems='center' xs={12}>
          <CheckCircle fontSize='large' style={{ color: GREEN_MOBILE, fontSize: '3.5rem' }} />
          <Typography className={classes.titleContainer}>Sukses</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid xs={12} container justify='center'>
          <Grid xs={10}>
            <Typography align='center'>Sales order berasil di convert menjadi invoice</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid xs={12} container justify='center'>
          <Grid xs={10}>
            <Button size='small' fullWidth className={classes.button} color='primary' onClick={() => handleClick()}>
              Tutup
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSuccess;
